export const CallApi = async () => {
  console.log(">CallApi");

  const response = await fetch("https://api.openai.com/v1/chat/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${process.env.REACT_APP_GPT_API_KEY}`,
    },
    body: JSON.stringify({
      model: "gpt-3.5-turbo",
      messages: [
        {
          role: "user",
          content: "중급 사용자를 위한 영어 단어 3개 알려줘 ",
        },
      ],
      temperature: 0.5,
      max_tokens: 200,
    }),
  });

  const responseData = await response.json();
  console.log("responseData", responseData);

  return responseData;
};
